import React from 'react'
import { DialogContent, Modal } from '../../../../../../components/Modal/Modal'
import { useShow } from '../../../../../../hooks/useShow'
import { CreateCharacter, CreateCharacterProps } from '../CreateCharacter/CreateCharacter'

interface Props extends CreateCharacterProps {
  children: (showModal: () => void) => any
}

export const CreateCharacterModal: React.FC<Props> = ({ children, afterCreate, ...props }) => {
  const { show, doHide, doShow } = useShow()
  return (
    <>
      {children(doShow)}
      <Modal open={show} onClose={doHide} title="Stwórz postać">
        <DialogContent>
          <CreateCharacter
            {...props}
            afterCreate={c => {
              afterCreate && afterCreate(c)
              doHide()
            }}
          />
        </DialogContent>
      </Modal>
    </>
  )
}
